
<p-dialog
    [header]="dialogTitle"
    [(visible)]="showDialog"
    showEffect="fade"
    [modal]="true"
    [closable]="false"
    appendTo="body"
    [style]="getDialogStyle()">
      <ng-content select="[custom-content-above-rules]"></ng-content>
      <div *ngIf="showRules">
        <div class="admin-filter" *ngIf="sysAdminFilterText" >
          <div class="admin-filter-header">Filtered by:</div>
          <div class="admin-filter-rule" *ngFor="let rule of sysAdminFilterText">{{rule}}</div>
        </div>
        <mojo-query-builder [query]='tempFilter' [config]='resolvedConfig' [allowRuleset]="false"></mojo-query-builder>
      </div>
      <ng-content select="[custom-content]"></ng-content>
  <p-footer>
    <div class="validation-summary">
      <label *ngFor="let field of invalidFields" class="text-danger validation-message">
        Please enter a valid value for {{field}}
      </label>
    </div>
    <div class="btn-group" role="group" aria-label="...">
      <button type="button" *ngIf="showReset" pButton icon="fa-fw fa fa-undo" (click)="handleReset()" label="Reset"></button>
      <button type="button" pButton icon="fa-fw fa fa-check" (click)="saveAndClose()" label="Ok" [disabled]="okButtonDisabled"></button>
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>
</p-dialog>
